import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private apiUrl = environment.apiUrl;
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient) {}

  loginOrganization(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/login`, data, {
      headers: this.headers,
    });
  }
  registerOrganization(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/organizationRegister`, data);
  }
  emailCheck(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/forgot-password`, data);
  }
  changePassword(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/reset-password`, data);
  }
  verifyOtp(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/verify-otp`, data);
  }
  resendOtp(userId: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/send-otp/${userId}`, {});
  }
}
